import React, { useState, useEffect } from 'react';
import Parser from 'html-react-parser';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import styles from './YourEstimate.module.css';
import TrainingsPanel from '../../TrainingsPanel/TrainingsPanel';
import Estimate from '../../Estimate/Estimate';
import Banner from '../../Banner/Banner';

import {
  calcDesignEstimate,
  calcDevelopmentEstimate,
} from '../../../functions/pricing/calcEstimate';

const EstimateSection = ({
  showBudget,
  modules,
  showBanner,
  title,
  description,
  setShowSignup,
  page,
  addMargin,
  showSidePanel,
}) => {
  const [active, setActive] = useState('S');
  const { answers } = useSelector((state) => state.Pricing);
  const [designEstimate] = useState(calcDesignEstimate(answers));
  const [developmentEstimate] = useState(calcDevelopmentEstimate(answers));
  const [amount] = useState(designEstimate + developmentEstimate * 2);
  const handleActiveBtn = (estimate) => {
    if (estimate <= 10000) setActive('S');
    else if (estimate > 10000 && estimate <= 15000) setActive('M');
    else if (estimate > 15000 && estimate <= 25000) setActive('L');
    else if (estimate > 25000) setActive('XL');
  };
  useEffect(() => {
    if (amount) {
      handleActiveBtn(amount);
    }
  }, [amount]);
  return (
    <div className={styles.contentHolder}>
      {showSidePanel && (
        <TrainingsPanel
          modules={modules}
          setShowSignup={setShowSignup}
          page={page}
        />
      )}
      <div className={styles.contentRight}>
        {page === 'more' && (
          <Banner
            heading="Your custom price estimate"
            linkText="Here"
            to="/"
            addMargin={addMargin}
          >
            <p>
              This estimate is based on over 100 apps built.
              {' '}
              <br />
              Your final price will depend on the level of detail and the
              complexity of the APIs we need to integrate with.
            </p>
          </Banner>
        )}
        {showBanner && page === 'intro' && (
          <Banner heading={title} linkText="Here" to="/" addMargin={addMargin}>
            <p>{Parser(description)}</p>
          </Banner>
        )}
        {showBudget && <Estimate page={page} />}
        {showBanner && page !== 'intro' && page !== 'sign-up' && page !== 'estimation' && (
          <Banner
            heading={title}
            linkText="Here"
            to="/"
            addMargin={page === 'more' ? false : addMargin}
          >
            <p>{Parser(description)}</p>
          </Banner>
        )}
        {showBanner && page === 'sign-up' && (
          <Banner
            heading={title}
            linkText="Here"
            to="/"
            addMargin={page === 'more' ? false : addMargin}
          >
            <div className={styles.sizeHolder}>
              <div className={styles.textHolder}>
                <p className="section__p">
                  Based on our assesment, your project size is:
                </p>
              </div>
              <div className={styles.btnWrap}>
                <button
                  className={clsx(
                    styles.btnSize,
                    active === 'S' ? styles.active : ''
                  )}
                  type="button"
                >
                  Small (S)
                </button>
                <button
                  className={clsx(
                    styles.btnSize,
                    active === 'M' ? styles.active : ''
                  )}
                  type="button"
                >
                  Medium (M)
                </button>
                <button
                  className={clsx(
                    styles.btnSize,
                    active === 'L' ? styles.active : ''
                  )}
                  type="button"
                >
                  Large (L)
                </button>
                <button
                  className={clsx(
                    styles.btnSize,
                    active === 'XL' ? styles.active : ''
                  )}
                  type="button"
                >
                  Xtra Large (XL)
                </button>
              </div>
            </div>
          </Banner>
        )}
      </div>
    </div>
  );
};
export default EstimateSection;
